import { Component, computed, signal } from "@angular/core";
import { MenuItem } from "primeng/api";
import { isDevelopment } from "../../_shared/environment-helper";
import { NetworkStatusService } from "../../_services/network-status.service";
import { toSignal } from "@angular/core/rxjs-interop";
import { DataCleanupService } from "../../_services/data-cleanup.service";
import { OfflineSetupService } from "../../_offline/services/offline-setup.service";

@Component({
  selector: "app-dev-menu",
  templateUrl: "./dev-menu.component.html",
  styleUrl: "./dev-menu.component.scss",
  standalone: false
})
export class DevMenuComponent {
  public developmentMenu = computed<MenuItem[]>(() => this.buildDevelopmentMenu());
  public applicationMode = toSignal(this.networkStatusService.applicationMode$);
  public isOnline = toSignal(this.networkStatusService.isOnlineObserver());
  public dataCleanUpInProgress = signal<boolean>(false);

  constructor(
    private networkStatusService: NetworkStatusService,
    private dataCleanupService: DataCleanupService,
    private offlineSetupService: OfflineSetupService
  ) {}

  private buildDevelopmentMenu(): MenuItem[] {
    if (!isDevelopment()) {
      return [];
    }

    const applicationMode = this.applicationMode();

    const devMenu: MenuItem[] = [
      {
        icon: "pi pi-eraser",
        label: "Reset tenant data",
        command: this.resetTenantData,
        disabled: !this.isOnline() || this.dataCleanUpInProgress()
      }
    ];

    if (applicationMode?.platform === "desktop") {
      devMenu.push({
        icon: "pi pi-trash",
        label: "Reset app data",
        command: this.resetAppData
      });
    }

    return devMenu;
  }

  private resetTenantData = () => {
    if (!this.isOnline()) {
      return;
    }

    if (window.confirm("This will reset tenant data. Are you sure you want to proceed?")) {
      this.dataCleanUpInProgress.set(true);

      this.dataCleanupService.deleteTenantData().subscribe({
        next: () => {
          window.location.reload();
          this.dataCleanUpInProgress.set(true);
        },
        error: (error) => {
          console.error("Failed to delete tenant data:", error);
          this.dataCleanUpInProgress.set(false);
        }
      });
    }
  };

  private resetAppData = () => {
    if (window.confirm("This will reset application data. Are you sure you want to proceed?")) {
      this.offlineSetupService.resetAppData().subscribe();
    }
  };
}
